import { inject, Injectable, NgZone, OnDestroy } from '@angular/core';
import { Map as LeafletMap, LeafletMouseEvent } from 'leaflet';
import { Subject } from 'rxjs';
import { MapMode, MapModes } from './shared';

interface SelectModeOptions {
  stopTooltip: string;
}

@Injectable()
export class SelectMode
  extends MapMode<SelectModeOptions>
  implements OnDestroy
{
  protected readonly zone = inject(NgZone);

  type = MapModes.SELECT;

  mapClick$ = new Subject<{ event: LeafletMouseEvent; map: LeafletMap }>();

  setup() {
    this.map.on('click', this.handleClick);
  }

  protected readonly handleClick = (event: LeafletMouseEvent) => {
    this.zone.run(() => {
      this.mapClick$.next({ event, map: this.map });
    });
  };

  ngOnDestroy() {
    this.mapClick$.complete();
    this.map.off('click', this.handleClick);
  }
}

@Injectable()
export class SelectSurveyLabelMode extends SelectMode {
  override type = MapModes.SELECT_SL;
}
